import { render, staticRenderFns } from "./AddTFDelivery.vue?vue&type=template&id=519f9bea&"
import script from "./AddTFDelivery.vue?vue&type=script&lang=js&"
export * from "./AddTFDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports